import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports

// Set the default state values for each context
const HelpDrawerContext = /*#__PURE__*/createContext({});
const useHelpDrawerHook = () => {
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const toggleHelpDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  return {
    isDrawerOpen,
    toggleHelpDrawer
  };
};
export const HelpDrawerContextProvider = ({
  children
}) => {
  const helpDraw = useHelpDrawerHook();
  return /*#__PURE__*/React.createElement(HelpDrawerContext.Provider, {
    value: helpDraw
  }, children);
};
export const useHelpDrawer = () => {
  return useContext(HelpDrawerContext);
};
HelpDrawerContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};